import { Directive, ElementRef, inject, input, Renderer2 } from '@angular/core'
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop'
import { delay, filter, map, mergeWith, Subject, switchMap, withLatestFrom } from 'rxjs'

@Directive({
	selector: '[mosClickClass]',
	host: {
		'(click)': 'click()',
	},
})
export class ClickClassDirective {
	readonly mosClickClassTimer = input(200)
	readonly mosClickClass = input('mos-click')

	click$ = new Subject<void>()
	clickClass$ = toObservable(this.mosClickClass).pipe(filter((value) => !!value))
	clickClassTimer$ = toObservable(this.mosClickClassTimer).pipe(filter((value) => !!value))
	// Emit true for 200ms when clicked
	clickTimer$ = this.clickClassTimer$.pipe(
		switchMap((timer) =>
			this.click$.pipe(
				map(() => true),
				mergeWith(
					this.click$.pipe(
						delay(timer),
						map(() => false),
					),
				),
			),
		),
	)
	private renderer = inject(Renderer2)
	private hostElement = inject(ElementRef)

	constructor() {
		this.clickTimer$
			.pipe(takeUntilDestroyed(), withLatestFrom(this.clickClass$))
			.subscribe(([clicked, classValue]) => {
				if (clicked) {
					this.addClickClass(classValue)
				} else {
					this.removeClickClass(classValue)
				}
			})
	}

	click() {
		this.click$.next()
	}

	addClickClass(value: string) {
		this.renderer.addClass(this.hostElement.nativeElement, value)
	}

	removeClickClass(value: string) {
		this.renderer.removeClass(this.hostElement.nativeElement, value)
	}
}
